import React, { useState } from "react";
import Slider from "react-slick";

import {
  Root,
  Container,
  CardsWrapper,
  GrandSlider,
  CardContainer,
  GrandText,
  Badge,
  CardTitle,
  CardDesc,
  List,
  ListItem,
  SecondSlider,
} from "./Sweepstakes.style";

import grandPrizeSrc from "../../images/grand-prize.svg";
import firstPrizeSrc from "../../images/first-prize.svg";
import secondPrizeSrc from "../../images/second-prize.svg";

import { grandPrize, firstPrize, secondPrize, sliderSettings } from "./config";
import SectionTitle from "../SectionTitle/SectionTitle";
import SliderStyled from "../SliderStyled/SliderStyled";
import { Button } from "../Button/Button";
import { ModalEntry } from "../../nmd2025/microsite/ModalEntry/ModalEntry";

const Sweepstakes = () => {
  const [entryShow, setEntryShow] = useState(false);

  return (
    <Root>
      <Container>
        <SectionTitle title="sweepstakes" subtitle="National Moonshine Week" />

        <CardsWrapper className="--grand">
          <GrandSlider>
            <SliderStyled>
              <Slider {...sliderSettings}>
                {grandPrize.map((slide, idx) =>
                  slide.href == null ? (
                    <img key={idx} src={slide.image} alt="" />
                  ) : (
                    <a key={idx} href={slide.href} target="_blank">
                      <img src={slide.image} alt="" />
                    </a>
                  ),
                )}
              </Slider>
            </SliderStyled>
          </GrandSlider>

          <GrandText>
            <Badge src={grandPrizeSrc} alt="Grand Prize" $isGrand />
            <CardTitle>
              All Inclusive VIP trip to Nashville TN (1 winner)
            </CardTitle>
            <CardDesc>
              Ole Smoky is sending moonshine fans to Nashville, Tennessee for a
              weekend filled with food, fun, music and, of course, a little
              shine!
            </CardDesc>

            <List>
              <ListItem>
                Round trip airfare for four (4) people to Nashville Tennessee
              </ListItem>
              <ListItem>
                Hotel for four (4) ppl in Nashville TN, three nights
              </ListItem>
              <ListItem>
                Private Moonshine Tour at the 6th & Peabody Distillery in
                Nashville
              </ListItem>
              <ListItem>Ole Smoky Gift Basket</ListItem>
              <ListItem>
                VIP transportation from hotel to airport + return
              </ListItem>
              <ListItem>Gift card for meals</ListItem>
            </List>
          </GrandText>
        </CardsWrapper>

        <CardsWrapper className="--first">
          <CardContainer>
            <SecondSlider>
              <SliderStyled>
                <Slider {...sliderSettings} autoplaySpeed={4000}>
                  {firstPrize.map((slide) => (
                    <img key={slide.id} src={slide.image} alt="" />
                  ))}
                </Slider>
              </SliderStyled>
              <Badge src={firstPrizeSrc} alt="First Prize" />
            </SecondSlider>

            <CardTitle>
              One RTIC Cocktail Cooler + Yeti Tumbler
              <br />
              (3 Winners)
            </CardTitle>
            <CardDesc>
              Three lucky winners will take home a combo pack featuring an RTIC
              Cooler and a Yeti Tumbler—perfect for keeping your moonshine
              ice-cold and refreshing.
            </CardDesc>
          </CardContainer>

          <CardContainer>
            <SecondSlider>
              <SliderStyled>
                <Slider {...sliderSettings} autoplaySpeed={4500}>
                  {secondPrize.map((slide) => (
                    <img key={slide.id} src={slide.image} alt="" />
                  ))}
                </Slider>
              </SliderStyled>
              <Badge src={secondPrizeSrc} alt="Second Prize" />
            </SecondSlider>

            <CardTitle>
              Ole Smoky Moonshine Club Hat
              <br />
              (100 winners)
            </CardTitle>
            <CardDesc>
              We’re selecting 100 lucky winners to join the Moonshiners Club and
              snag a brand new trucker hat.
            </CardDesc>
          </CardContainer>
        </CardsWrapper>

        <Button
          type="button"
          onClick={() => setEntryShow(true)}
          style={{ width: "fit-content" }}
        >
          enter for a chance to win
        </Button>
      </Container>

      {entryShow && <ModalEntry onClose={() => setEntryShow(false)} />}
    </Root>
  );
};

export default Sweepstakes;
